import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import CommonService from "../../services/common.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import PlayerGameBar from "./PlayerGameBar";
import { isUserPaid } from "../../utils/userPremiumUtils";
import GamePassModal from "../GamePassModal";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const PlayerGraph = () => {
  useAutoAddQueryString();
  const [playerList, setPlayerList] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const [isPlayerGameBarActive, setIsPlayerGameBarActive] = useState(false);
  const [isPlayerChartActive, setIsPlayerChartActive] = useState(true);
  const userPaidForClub = isUserPaid();
  let [searchParams, setSearchParams] = useSearchParams(); // Destructure setSearchParams
  const navigate = useNavigate();
  var playerId = searchParams.get("player_id");
  useEffect(() => {
    if (userPaidForClub !== 1) {
      navigate("/players");
    }

    CommonService.getTimelineData("fantasy_points").then((res) => {
      if (res.success) {
        setPlayerList(res.players);
      }
    });
    if (playerId) {
      getPlayerGraphData(playerId);
    }
  }, [playerId]);
  const getPlayerGraphData = (playerId) => {
    setSelectedPlayerId(playerId);
    CommonService.playerChart(playerId).then((res) => {
      if (res.status === 200) {
        setPlayerGraphDataData(res.data.datasets);
        setLabelNames(res.data.labels);
        setPriceChange(res.data.priceChange);
        setGoData(res.data.goData);
        setGksData(res.data.gksData);
        setOgData(res.data.ogData);
        setAssistsData(res.data.assistsData);
        setPiData(res.data.piData);
      }
    });
  };

  const [playerGraphData, setPlayerGraphDataData] = useState([]);
  const [priceChange, setPriceChange] = useState([]);
  const [labelNames, setLabelNames] = useState([]);

  const [goData, setGoData] = useState([]);
  const [gksData, setGksData] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [assistsData, setAssistsData] = useState([]);
  const [piData, setPiData] = useState([]);
  const [twData, setTwData] = useState([]);
  const [psData, setPsData] = useState([]);
  const [pmData, setPmData] = useState([]);
  const [gcdData, setGcdData] = useState([]);
  const [ycdData, setYcdData] = useState([]);
  const [rcdData, setRcdData] = useState([]);
  const [cstData, setCstData] = useState([]);
  const [p60Data, setP60Data] = useState([]);
  const [p60PlusData, setP60PlusData] = useState([]);

  const [showGamePass, setShowGamePass] = useState(false);
  const handleCloseGamePass = () => setShowGamePass(false);

  const handlePlayerSelect = (playerId) => {
    if (userPaidForClub !== 1) {
      setShowGamePass(true);
      return false;
    }
    setSelectedPlayerId(playerId);
    setSearchParams({ player_id: playerId });
    if (isPlayerChartActive) {
      CommonService.playerChart(playerId).then((res) => {
        if (res.status === 200) {
          setPlayerGraphDataData(res.data.datasets);
          setLabelNames(res.data.labels);
          setPriceChange(res.data.priceChange);
          setGoData(res.data.goData);
          setGksData(res.data.gksData);
          setOgData(res.data.ogData);
          setAssistsData(res.data.assistsData);
          setPiData(res.data.piData);

          setTwData(res.data.twData);
          setPsData(res.data.psData);
          setPmData(res.data.pmData);
          setGcdData(res.data.gcdData);
          setYcdData(res.data.ycdData);
          setRcdData(res.data.rcdData);
          setCstData(res.data.cstData);
          setP60Data(res.data.p60Data);
          setP60PlusData(res.data.p60PlusData);
        }
      });
    }
    if (isPlayerGameBarActive) {
      CommonService.getPlayerGameBarGraph(playerId).then((res) => {
        if (res.success) {
          setGoRangeData(res.goData);
          setGksRangeData(res.gksData);
          setOgRangeData(res.ogData);
          setAstRangeData(res.assistsData);
          setPiRangeData(res.piData);
          setTwRangeData(res.piData);
          setPsRangeData(res.piData);
          setPmRangeData(res.piData);
          setGcdRangeData(res.piData);
          setYcdRangeData(res.piData);
          setRcdRangeData(res.piData);
          setCstRangeData(res.piData);
          setP60RangeData(res.piData);
          setP60PlusRangeData(res.piData);
          setFpsRangeData(res.fpRangeData);
        }
      });
    }
  };
  const dataValues = Object.values(playerGraphData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPriceChangeValues = Object.values(priceChange).map((value) =>
    parseFloat(value, 10)
  );

  const dataGoValues = Object.values(goData).map((value) =>
    parseFloat(value, 10)
  );
  const dataGksValues = Object.values(gksData).map((value) =>
    parseFloat(value, 10)
  );
  const dataOgValues = Object.values(ogData).map((value) =>
    parseFloat(value, 10)
  );
  const dataAstValues = Object.values(assistsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPiValues = Object.values(piData).map((value) =>
    parseFloat(value, 10)
  );

  const dataTwValues = Object.values(twData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPsValues = Object.values(psData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPmValues = Object.values(pmData).map((value) =>
    parseFloat(value, 10)
  );
  const dataGcdValues = Object.values(gcdData).map((value) =>
    parseFloat(value, 10)
  );
  const dataYcdValues = Object.values(ycdData).map((value) =>
    parseFloat(value, 10)
  );
  const dataRcdValues = Object.values(rcdData).map((value) =>
    parseFloat(value, 10)
  );
  const dataCstValues = Object.values(cstData).map((value) =>
    parseFloat(value, 10)
  );
  const dataP60Values = Object.values(p60Data).map((value) =>
    parseFloat(value, 10)
  );
  const dataP60PlusValues = Object.values(p60PlusData).map((value) =>
    parseFloat(value, 10)
  );

  const labelNamesa = Object.keys(labelNames);

  const chartData = {
    series: [
      {
        name: "Fantasy Points",
        data: dataValues,
      },
    ],
  };

  const chartOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Points",
      align: "left",
    },
  };

  const chartData1 = {
    series: [
      {
        name: "Fantasy Value",
        data: dataPriceChangeValues,
      },
    ],
  };

  const chartOptions1 = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Value",
      align: "left",
    },
  };

  // runs graph data
  const formattedGoData = {
    series: [
      {
        name: "Goal Per Match",
        data: dataGoValues,
      },
    ],
  };

  const goOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Goal Per Match",
      align: "left",
    },
  };
  // fours graph data
  const formattedGksData = {
    series: [
      {
        name: "GK Saves Per Match",
        data: dataGksValues,
      },
    ],
  };

  const gksOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "GK Saves Per Match",
      align: "left",
    },
  };
  // sixes graph data
  const formattedOgData = {
    series: [
      {
        name: "Own Goal Per Match",
        data: dataOgValues,
      },
    ],
  };

  const ogOptions = {
    chart: {
      id: "Own Goal Per Match",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Own Saves Per Match",
      align: "left",
    },
  };
  // maidens graph data
  const formattedAstData = {
    series: [
      {
        name: "Assist Per Match",
        data: dataAstValues,
      },
    ],
  };

  const astOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Assist Per match",
      align: "left",
    },
  };
  // wks graph data
  const formattedPiData = {
    series: [
      {
        name: "Passes Intercepted Per Match",
        data: dataPiValues,
      },
    ],
  };

  const piOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Passes Intercepted Per Match",
      align: "left",
    },
  };

  const formattedTwData = {
    series: [
      {
        name: "Tackles Won Per Match",
        data: dataTwValues,
      },
    ],
  };

  const twOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Tackles Won Per Match",
      align: "left",
    },
  };

  const formattedPsData = {
    series: [
      {
        name: "Penalty Saves Per Match",
        data: dataPsValues,
      },
    ],
  };

  const psOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Penalty Saves Per Match",
      align: "left",
    },
  };

  const formattedPmData = {
    series: [
      {
        name: "Penalty Miss Per Match",
        data: dataPmValues,
      },
    ],
  };

  const pmOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Penalty Miss Per Match",
      align: "left",
    },
  };

  const formattedGcdData = {
    series: [
      {
        name: "Green Card Per Match",
        data: dataGcdValues,
      },
    ],
  };

  const gcdOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Green Card Per Match",
      align: "left",
    },
  };
  const formattedYcdData = {
    series: [
      {
        name: "Yellow Card Per Match",
        data: dataYcdValues,
      },
    ],
  };

  const ycdOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Yellow Card Per Match",
      align: "left",
    },
  };
  const formattedRcdData = {
    series: [
      {
        name: "Red Card Per Match",
        data: dataRcdValues,
      },
    ],
  };

  const rcdOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Red Card Per Match",
      align: "left",
    },
  };

  const formattedCstData = {
    series: [
      {
        name: "Clean Sheet Per Match",
        data: dataCstValues,
      },
    ],
  };

  const cstOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Clean Sheet Per Match",
      align: "left",
    },
  };
  const formattedP60Data = {
    series: [
      {
        name: "Played 60mins Per Match",
        data: dataP60Values,
      },
    ],
  };

  const p60Options = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Played 60mins Per Match",
      align: "left",
    },
  };
  const formattedP60PlusData = {
    series: [
      {
        name: "Played 60+mins Per Match",
        data: dataP60PlusValues,
      },
    ],
  };

  const p60PlusOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Played 60+mins Per Match",
      align: "left",
    },
  };

  const [goRangeData, setGoRangeData] = useState([]);
  const [gksRangeData, setGksRangeData] = useState([]);
  const [ogRangeData, setOgRangeData] = useState([]);
  const [astRangeData, setAstRangeData] = useState([]);
  const [piRangeData, setPiRangeData] = useState([]);
  const [twRangeData, setTwRangeData] = useState([]);
  const [psRangeData, setPsRangeData] = useState([]);
  const [pmRangeData, setPmRangeData] = useState([]);
  const [gcdRangeData, setGcdRangeData] = useState([]);
  const [ycdRangeData, setYcdRangeData] = useState([]);
  const [rcdRangeData, setRcdRangeData] = useState([]);
  const [cstRangeData, setCstRangeData] = useState([]);
  const [p60RangeData, setP60RangeData] = useState([]);
  const [p60PlusRangeData, setP60PlusRangeData] = useState([]);

  const [fpsRangeData, setFpsRangeData] = useState([]);

  const showPlayerGamebar = () => {
    setIsPlayerGameBarActive(true);
    setIsPlayerChartActive(false);
    if (playerId) {
      CommonService.getPlayerGameBarGraph(playerId).then((res) => {
        if (res.success) {
          setGoRangeData(res.goData);
          setGksRangeData(res.gksData);
          setOgRangeData(res.ogData);
          setAstRangeData(res.assistsData);
          setPiRangeData(res.piData);
          setTwRangeData(res.twData);
          setPsRangeData(res.psData);
          setPmRangeData(res.pmData);
          setGcdRangeData(res.gcdData);
          setYcdRangeData(res.ycdData);
          setRcdRangeData(res.rcdData);
          setCstRangeData(res.cstData);
          setP60RangeData(res.p60Data);
          setP60PlusRangeData(res.p60PlusData);

          setFpsRangeData(res.fpRangeData);
        }
      });
    }
  };
  const chartTabOpen = () => {
    setIsPlayerGameBarActive(false);
    setIsPlayerChartActive(true);
  };
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Player Charts</h2>
            </div>
            <div className="filter_content">
              <div className="choosen_selct">
                <select
                  className="form-control"
                  disabled=""
                  onChange={(e) => handlePlayerSelect(e.target.value)}
                  value={selectedPlayerId || ""}
                >
                  <option value={""}>Select Player</option>
                  {playerList &&
                    playerList.map((item, key) => (
                      <option key={key} value={item?.player_id}>
                        {item?.full_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Overall"
                  type="button"
                  role="tab"
                  aria-controls="Overall"
                  aria-selected="true"
                  onClick={chartTabOpen}
                >
                  Charts
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Bating-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Bating"
                  type="button"
                  role="tab"
                  aria-controls="Bating"
                  aria-selected="true"
                  onClick={showPlayerGamebar}
                >
                  Bars
                </button>
              </li>
            </ul>
            <div className="tab-content" id="timeline">
              <div
                className="tab-pane fade show active"
                id="Overall"
                role="tabpanel"
                aria-labelledby="Overall-tab"
              >
                <ul className="sponsor_list bonus-card">
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={chartOptions}
                        series={chartData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={chartOptions1}
                        series={chartData1.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={goOptions}
                        series={formattedGoData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={gksOptions}
                        series={formattedGksData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={ogOptions}
                        series={formattedOgData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={astOptions}
                        series={formattedAstData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={psOptions}
                        series={formattedPsData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={pmOptions}
                        series={formattedPmData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={gcdOptions}
                        series={formattedGcdData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={ycdOptions}
                        series={formattedYcdData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={rcdOptions}
                        series={formattedRcdData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>

                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={cstOptions}
                        series={formattedCstData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={p60Options}
                        series={formattedP60Data.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="sponsorslide">
                      <Chart
                        options={p60PlusOptions}
                        series={formattedP60PlusData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div
                className="tab-pane fade"
                id="Bating"
                role="tabpanel"
                aria-labelledby="Bating-tab"
              >
                <PlayerGameBar
                  goRangeData={goRangeData}
                  gksRangeData={gksRangeData}
                  ogRangeData={ogRangeData}
                  astRangeData={astRangeData}
                  piRangeData={piRangeData}
                  twRangeData={twRangeData}
                  psRangeData={psRangeData}
                  pmRangeData={pmRangeData}
                  gcdRangeData={gcdRangeData}
                  ycdRangeData={ycdRangeData}
                  rcdRangeData={rcdRangeData}
                  cstRangeData={cstRangeData}
                  p60RangeData={p60RangeData}
                  p60PlusRangeData={p60PlusRangeData}
                  fpsRangeData={fpsRangeData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <GamePassModal
        showGamePass={showGamePass}
        handleCloseGamePass={handleCloseGamePass}
      />
    </>
  );
};

export default PlayerGraph;
